export const FONT_MAPPINGS = [
    { original: 'Calibri', substitute: 'Arial, sans-serif', exactMatch: false },
    { original: 'Calibri Light', substitute: 'Arial, sans-serif', exactMatch: false },
    { original: 'Arial', substitute: 'Arial, sans-serif', exactMatch: true },
    { original: 'Arial Black', substitute: 'Arial Black, sans-serif', exactMatch: true },
    { original: 'Arial Narrow', substitute: 'Arial Narrow, Arial, sans-serif', exactMatch: true },
    { original: 'Times New Roman', substitute: 'Times New Roman, serif', exactMatch: true },
    { original: 'Times', substitute: 'Times, Times New Roman, serif', exactMatch: true },
    { original: 'Georgia', substitute: 'Georgia, serif', exactMatch: true },
    { original: 'Verdana', substitute: 'Verdana, sans-serif', exactMatch: true },
    { original: 'Trebuchet MS', substitute: 'Trebuchet MS, sans-serif', exactMatch: true },
    { original: 'Courier New', substitute: 'Courier New, monospace', exactMatch: true },
    { original: 'Courier', substitute: 'Courier, Courier New, monospace', exactMatch: true },
    { original: 'Comic Sans MS', substitute: 'Comic Sans MS, cursive', exactMatch: true },
    { original: 'Impact', substitute: 'Impact, sans-serif', exactMatch: true },
    { original: 'Tahoma', substitute: 'Tahoma, sans-serif', exactMatch: true },
    { original: 'Segoe UI', substitute: 'Segoe UI, Arial, sans-serif', exactMatch: false },
    { original: 'Segoe UI Light', substitute: 'Segoe UI, Arial, sans-serif', exactMatch: false },
    { original: 'Segoe UI Semibold', substitute: 'Segoe UI, Arial, sans-serif', exactMatch: false },
    { original: 'Cambria', substitute: 'Georgia, serif', exactMatch: false },
    { original: 'Cambria Math', substitute: 'Georgia, serif', exactMatch: false },
    { original: 'Consolas', substitute: 'Consolas, Courier New, monospace', exactMatch: false },
    { original: 'Corbel', substitute: 'Arial, sans-serif', exactMatch: false },
    { original: 'Franklin Gothic Medium', substitute: 'Arial Black, sans-serif', exactMatch: false },
    { original: 'Garamond', substitute: 'Garamond, Georgia, serif', exactMatch: false },
    { original: 'Century Gothic', substitute: 'Arial, sans-serif', exactMatch: false },
    { original: 'Book Antiqua', substitute: 'Georgia, serif', exactMatch: false },
    { original: 'Palatino Linotype', substitute: 'Palatino, Georgia, serif', exactMatch: false },
    { original: 'Palatino', substitute: 'Palatino, Georgia, serif', exactMatch: false },
    { original: 'Lucida Sans', substitute: 'Lucida Sans, Arial, sans-serif', exactMatch: false },
    { original: 'Lucida Console', substitute: 'Lucida Console, Courier New, monospace', exactMatch: false },
];
const fontMappingLookup = new Map(FONT_MAPPINGS.map(mapping => [mapping.original.toLowerCase(), mapping]));
export function getSubstituteFont(fontFamily) {
    if (!fontFamily) {
        return 'Arial, sans-serif';
    }
    const cleanFont = fontFamily.replace(/['"]/g, '').trim();
    const mapping = fontMappingLookup.get(cleanFont.toLowerCase());
    if (mapping) {
        return mapping.substitute;
    }
    if (cleanFont.includes(',')) {
        return cleanFont;
    }
    const lowerFont = cleanFont.toLowerCase();
    if (lowerFont.includes('sans') || lowerFont.includes('gothic')) {
        return `${cleanFont}, Arial, sans-serif`;
    }
    if (lowerFont.includes('serif') || lowerFont.includes('times') || lowerFont.includes('garamond')) {
        return `${cleanFont}, Georgia, serif`;
    }
    if (lowerFont.includes('mono') || lowerFont.includes('courier') || lowerFont.includes('console')) {
        return `${cleanFont}, Courier New, monospace`;
    }
    if (lowerFont.includes('script') || lowerFont.includes('cursive') || lowerFont.includes('comic')) {
        return `${cleanFont}, Comic Sans MS, cursive`;
    }
    return `${cleanFont}, Arial, sans-serif`;
}
export function isFontExactMatch(fontFamily) {
    const cleanFont = fontFamily.replace(/['"]/g, '').trim();
    const mapping = fontMappingLookup.get(cleanFont.toLowerCase());
    return mapping?.exactMatch ?? false;
}
export function analyzeFonts(fonts) {
    const uniqueFonts = Array.from(new Set(fonts));
    return uniqueFonts.map(font => {
        const substitute = getSubstituteFont(font);
        const exactMatch = isFontExactMatch(font);
        return {
            original: font,
            substitute,
            exactMatch,
        };
    });
}
//# sourceMappingURL=font-mapping.js.map